import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { authService } from "./services/authService";
import authReducer from "./slices/authSlice";
import allUserReducer from "./slices/allUserSlice";
import { allUserService } from "./services/allUserService";
import pdfRecordReducer from "./slices/pdfSlice";
import { pdfService } from "./services/pdfService";
import { allUserRoleService } from "./services/userRoleService";
import { allUserGroupService } from "./services/userGroupService";
import allUserRoleReducer from "./slices/allUserRoleSlice";
import allUserGroupReducer from "./slices/allUserGroupSlice";
import statesReducer from "./slices/statesSlice";
import { stateService } from "./services/stateService";
import countryReducer from "./slices/countrySlice";
import { countryService } from "./services/countryService";
import { allValueChainCategoriesService } from "./services/allValueChainCategoriesService";
import { allValueChainsService } from "./services/allValueChainsService";
import { allTermService } from "./services/allTermService";
import { allTermSetService } from "./services/allTermSetService";
import { allDataPipelinesCategoriesService } from "./services/allDataPipelinesCategoriesService";
import { allDataPipelinesService } from "./services/allDataPipelinesService";
import { allValueChainParagraphExtractService } from "./services/allValueChainParagraphExtractService";
import { allDataRecordsService } from "./services/allDataRecordsService";
import allValueChainCategoriesReducer from "./slices/allValueChainCategorySlice";
import allValueChainsReducer from "./slices/allValueChainsSlice";
import allTermReducer from "./slices/allTermSlice";
import allTermSetReducer from "./slices/allTermSetSlice";
import allDataPipelinesCategoriesReducer from "./slices/allDataPipelinesCategoriesSlice";
import allDataPipelinesReducer from "./slices/allDataPipelinesSlice";
import allValueChainParagraphExtractReducer from "./slices/allValueChainParagraphExtractSlice";
import allDataRecordsReducer from "./slices/allDataRecordsSlice";
import { webSearchService } from "./services/webSearchService";
import webSearchReducer from "./slices/webSearchSlice";
import { allAgentMasterService } from "./services/allAgentMasterService";
import agentMasterReducer from "./slices/allAgentMasterSlice";
import { favouritesService } from "./services/favouritesService";
import favouritesReducer from "./slices/favouriteSlice";
import { libraryCategoriesService } from "./services/libraryCategoriesService";
import libraryCategoryReducer from "./slices/libraryCategorySlice";
import { privateLibraryService } from "./services/privateLibraryService";
import privateLibraryReducer from "./slices/privateLibrarySlice";

export const store = configureStore({
  reducer: {
    // Slices
    auth: authReducer,
    allUser: allUserReducer,
    states: statesReducer,
    country: countryReducer,
    // city: cityReducer,
    allValueChainCategories: allValueChainCategoriesReducer,
    allValueChains: allValueChainsReducer,
    allTerm: allTermReducer,
    allTermSet: allTermSetReducer,
    allDataPipelinesCategories: allDataPipelinesCategoriesReducer,
    allDataPipelines: allDataPipelinesReducer,
    allValueChainParagraphExtract: allValueChainParagraphExtractReducer,
    allDataRecords: allDataRecordsReducer,
    webSearch: webSearchReducer,
    agentMaster: agentMasterReducer,
    pdfRecord: pdfRecordReducer,
    favourites: favouritesReducer,
    libraryCategories: libraryCategoryReducer,
    privateLibrary: privateLibraryReducer,
    allUserRole: allUserRoleReducer,
    allUserGroup: allUserGroupReducer,

    // Services
    [authService.reducerPath]: authService.reducer,
    [allUserService.reducerPath]: allUserService.reducer,
    [allValueChainCategoriesService.reducerPath]: allValueChainCategoriesService.reducer,
    [allValueChainsService.reducerPath]: allValueChainsService.reducer,
    [allTermService.reducerPath]: allTermService.reducer,
    [allTermSetService.reducerPath]: allTermSetService.reducer,
    [allDataPipelinesCategoriesService.reducerPath]:
      allDataPipelinesCategoriesService.reducer,
    [allDataPipelinesService.reducerPath]: allDataPipelinesService.reducer,
    [allValueChainParagraphExtractService.reducerPath]:
      allValueChainParagraphExtractService.reducer,
    [allDataRecordsService.reducerPath]: allDataRecordsService.reducer,
    [webSearchService.reducerPath]: webSearchService.reducer,
    [allAgentMasterService.reducerPath]: allAgentMasterService.reducer,
    [pdfService.reducerPath]: pdfService.reducer,
    [favouritesService.reducerPath]: favouritesService.reducer,
    [libraryCategoriesService.reducerPath]: libraryCategoriesService.reducer,
    [privateLibraryService.reducerPath]: privateLibraryService.reducer,
    [allUserRoleService.reducerPath]: allUserRoleService.reducer,
    [allUserGroupService.reducerPath]: allUserGroupService.reducer,
    [stateService.reducerPath]: stateService.reducer,
    [countryService.reducerPath]: countryService.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authService.middleware)
      .concat(allUserService.middleware)
      .concat(allValueChainCategoriesService.middleware)
      .concat(allValueChainsService.middleware)
      .concat(allTermService.middleware)
      .concat(allTermSetService.middleware)
      .concat(allDataPipelinesCategoriesService.middleware)
      .concat(allDataPipelinesService.middleware)
      .concat(allValueChainParagraphExtractService.middleware)
      .concat(allDataRecordsService.middleware)
      .concat(webSearchService.middleware)
      .concat(allAgentMasterService.middleware)
      .concat(pdfService.middleware)
      .concat(favouritesService.middleware)
      .concat(libraryCategoriesService.middleware)
      .concat(privateLibraryService.middleware)
      .concat(allUserRoleService.middleware)
      .concat(allUserGroupService.middleware)
      .concat(stateService.middleware)
      .concat(countryService.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
